import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Colors } from '../../../theme/colors';

/* This is not a loading placeholder. It is for when there is no icon available for a timeline event */
export function TimelineIconPlaceholder(props: { color?: string }) {
  const classes = useStyles(props);
  return <div className={classes.root}></div>;
}

const useStyles = makeStyles<Theme, { color?: string }>({
  root: {
    height: '16px',
    width: '16px',
    borderRadius: '50%',
    backgroundColor({ color = Colors.bookedScannedInProgressGray }) {
      return color;
    }
  }
});
